var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { cols: 12 } },
        [
          this.editingVisit < 1
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: 12 } },
                    [
                      _c("h3", [_vm._v("Resultados > Detalles")]),
                      _vm._v(" "),
                      this.searchCriteria.distributors
                        ? _c("div", [
                            _vm._v("\n          Viendo visitas de\n          "),
                            this.searchCriteria.manager
                              ? _c("span", [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(this.searchCriteria.manager) +
                                      " (" +
                                      _vm._s(
                                        this.searchCriteria.distributors.join(
                                          ", "
                                        )
                                      ) +
                                      ")\n          "
                                  )
                                ])
                              : _c("span", [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        this.searchCriteria.distributors.join(
                                          ", "
                                        )
                                      ) +
                                      "\n          "
                                  )
                                ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("p", [
                        _c("span", { staticStyle: { color: "#6daeb9" } }, [
                          _vm._v(
                            "\n            AVISO: Puede haber registros fuera del rango de fechas porque se incluyen las visitas de las semanas completas (desde el Sábado anterior al inicio-hasta el Viernes posterior al fin)\n          "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-btn",
                        {
                          staticClass: "mb-3",
                          attrs: { variant: "primary" },
                          on: {
                            click: function($event) {
                              _vm.goBackResults()
                            }
                          }
                        },
                        [_vm._v("Volver a resultados")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: 12 } }, [
                    _c("table", { staticClass: "table fixed_header" }, [
                      _c("thead", [
                        _c("tr", [
                          _c("th", { staticStyle: { "min-width": "75px" } }, [
                            _vm._v("Acciones")
                          ]),
                          _vm._v(" "),
                          _vm.searchCriteria["group"] === "entidad"
                            ? _c(
                                "th",
                                { staticStyle: { "min-width": "350px" } },
                                [_vm._v("Entidad")]
                              )
                            : _c(
                                "th",
                                { staticStyle: { "min-width": "350px" } },
                                [_vm._v("Dirección")]
                              ),
                          _vm._v(" "),
                          _c("th", { staticStyle: { "min-width": "200px" } }, [
                            _vm._v("Fecha planificada")
                          ]),
                          _vm._v(" "),
                          _c("th", { staticStyle: { "min-width": "200px" } }, [
                            _vm._v("Fecha realizada")
                          ]),
                          _vm._v(" "),
                          _c("th", { staticStyle: { "min-width": "250px" } }, [
                            _vm._v("Gestor")
                          ]),
                          _vm._v(" "),
                          _c("th", { staticStyle: { "min-width": "100px" } }, [
                            _vm._v("Estado")
                          ]),
                          _vm._v(" "),
                          _c("th", { staticStyle: { "min-width": "200px" } }, [
                            _vm._v("Tipo actividad")
                          ]),
                          _vm._v(" "),
                          _c("th", { staticStyle: { "min-width": "100px" } }, [
                            _vm._v("Resultado")
                          ]),
                          _vm._v(" "),
                          _c("th", { staticStyle: { "min-width": "250px" } }, [
                            _vm._v("Observaciones")
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.tableItems, function(item) {
                          return _c("tr", { key: item.id }, [
                            _c(
                              "td",
                              { staticStyle: { "min-width": "75px" } },
                              [
                                _c(
                                  "b-dropdown",
                                  {
                                    attrs: { variant: "link", "no-caret": "" }
                                  },
                                  [
                                    _c("template", { slot: "button-content" }, [
                                      _c("i", {
                                        staticClass: "fa fa-ellipsis-v",
                                        attrs: { "aria-hidden": "true" }
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-dropdown-item-button",
                                      {
                                        on: {
                                          click: function($event) {
                                            _vm.editRow(item.id_visita, $event)
                                          }
                                        }
                                      },
                                      [_vm._v("Editar")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-dropdown-item-button",
                                      {
                                        on: {
                                          click: function($event) {
                                            _vm.removeRow(item.id_visita)
                                          }
                                        }
                                      },
                                      [_vm._v("Eliminar")]
                                    )
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.searchCriteria["group"] === "entidad"
                              ? _c(
                                  "td",
                                  { staticStyle: { "min-width": "350px" } },
                                  [_vm._v(_vm._s(item.entidad))]
                                )
                              : _c(
                                  "td",
                                  { staticStyle: { "min-width": "350px" } },
                                  [_vm._v(_vm._s(item.direccion))]
                                ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "min-width": "200px" } },
                              [_vm._v(_vm._s(item.fecha_hora_proxima_visita))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "min-width": "200px" } },
                              [_vm._v(_vm._s(item.fecha_hora_visita))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "min-width": "250px" } },
                              [_vm._v(_vm._s(item.gestor))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "min-width": "100px" } },
                              [_vm._v(_vm._s(item.status_visita))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "min-width": "200px" } },
                              [_vm._v(_vm._s(item.tipo_actividad))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "min-width": "100px" } },
                              [_vm._v(_vm._s(item.resultado))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { "min-width": "250px" } },
                              [_vm._v(_vm._s(item.observaciones))]
                            )
                          ])
                        })
                      )
                    ])
                  ])
                ],
                1
              )
            : _c(
                "b-row",
                { staticClass: "scroll" },
                [
                  _c("b-col", { attrs: { cols: 12 } }, [
                    _c("h3", [
                      _vm._v("Resultados > Detalles > Editando visita")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: 12 } },
                    [
                      _vm.editingVisit && _vm.searchCriteria.group !== "entidad"
                        ? _c("ManageVisitsResultsDetailEdit", {
                            attrs: {
                              group: this.searchCriteria.group,
                              "id-visita": this.editingVisit
                            }
                          })
                        : _vm.editingVisit &&
                          _vm.searchCriteria.group === "entidad"
                        ? _c("ManageVisitsEntitiesResultsEdit", {
                            attrs: {
                              "id-visita": this.editingVisit,
                              manager: _vm.searchCriteria["manager"]
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/CommercialManagement/ManageVisitsResultsDetail.vue?vue&type=template&id=21caa93d&
// module id = null
// module chunks = 